/**
 *  +----------------------------------------------------------------------
 *  | Copyright notion All rights reserved.
 *  +----------------------------------------------------------------------
 *  | 未经许可不能去掉notion相关版权
 *  +----------------------------------------------------------------------
 *  | Author: 诺行
 *  +----------------------------------------------------------------------
 */
import request from '../request.js'

// 获取写号配置列表
export function listWriteCardConfig(params) {
    return request({
        url: 'writeCardConfig/list.do?',
        method: 'post',
        data: params
    })
}

// 批量导入写号配置
export function batchImportWriteCardConfig(params) {
    return request({
        url: 'writeCardConfig/batchImport.do?',   
        method: 'post',
        data: params,
        timeout: 20000,
        headers: {'Content-Type': 'multipart/form-data'}
    })
}

// 删除写号配置
export function deleteWriteCardConfig(params) {
    return request({
        url: 'writeCardConfig/delete.do?',
        method: 'post',
        data: params
    })
}

// 解冻卡片
export function unfreezeCard(params) {
    return request({
        url: 'writeCardConfig/unfreezeCard.do?',
        method: 'post',
        data: params
    })
}

// 冻结卡片
export function freezeCard(params) {
    return request({
        url: 'writeCardConfig/freezeCard.do?',
        method: 'post',
        data: params
    })
}

// 调整卡片顺序
export function adjustCardOrder(params) {
    return request({
        url: 'writeCardConfig/adjustCardOrder.do?',
        method: 'post',
        data: params
    })
}

// 批量删除写号配置
export function batchDeleteWriteCardConfig(params) {
    return request({
        url: 'writeCardConfig/batchDelete.do?',
        method: 'post',
        data: params,
        timeout: 20000,
        headers: {'Content-Type': 'multipart/form-data'}
    })
}

// 编辑备注
export function editRemark(params) {
    return request({
        url: 'writeCardConfig/editRemark.do?',
        method: 'post',
        data: params
    })
}

// 冻结卡批量导入
export function batchImportFrozenCard(params) {
    return request({
        url: 'frozenCard/batchImportSync.do',
        method: 'post',
        data: params,
        timeout: 20000,
        headers: {'Content-Type': 'multipart/form-data'}
    })
}
